import { ActionTypes } from "../constants/action-types";

const initialState = {
    MentorImageStaus:[],
};

export const UploadMentorImage = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.UPLOAD_MENTOR_IMAGE:
      return { ...state, MentorImageStaus: payload };
    default:
      return state;
  }
};